import React from "react";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/CarButton.css";

const CarButton = ({
  text,
  to,
  customClass = "",
  type = "button",
  target = null,
  onClick,
}) => {
  // Se è un submit button
  if (type === "submit") {
    return (
      <button type="submit" className={`btn ${customClass}`} onClick={onClick}>
        {text}
      </button>
    );
  }

  // Decido se usare HashLink (quando c'è un #) o il normale Link
  const isHash = typeof to === "string" && to.includes("#");

  if (isHash) {
    return (
      <HashLink
        smooth           // scroll animato
        to={to}
        className={`btn ${customClass}`}
        onClick={onClick}
      >
        {text}
      </HashLink>
    );
  }

  return (
    <Link
      to={to}
      target={target || undefined}
      className={`btn ${customClass}`}
      onClick={onClick}
    >
      {text}
    </Link>
  );
};

export default CarButton;
